<template>
  <div id="password-page">
    <v-app id="inspire">
      <v-layout align-center justify-center>
        <div id=password-form>
          <center>
            <v-btn :to="{path: 'login'}" class="ma-2" color="primary" text><v-icon darkleft>mdi-arrow-left</v-icon>LOGIN PAGE</v-btn>
            <h1>Fire Watch 101 Forgot Password</h1>
            <p>Enter your email address below. We will send you an email with a password reset link.</p>
          </center>
          <v-text-field ref="forgotPassword" autocorrect="off" autocapitalize="none" v-model="email" :rules="emailRules" label="Email Address" required> </v-text-field>
          <v-btn :disabled="!valid" color="success" @click="sendEmail(email)">SEND</v-btn>
        </div>
      </v-layout>
      </v-app>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
export default {
  data: () => ({
    name: 'Login',
    valid: true,
    email: '',
    loading: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary"

    },
    emailRules: [
        v => !!v || 'Email address is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Email must be valid'
      ],
    }),
  created(){
    if (localStorage.username){
      this.$router.push('watchlist')
      return
    }
    window.scrollTo(0,0);
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async sendEmail(email){    
      if (!this.$refs.forgotPassword.validate()){
        this.error("There is an error in the form");
        return
      }
      this.loading = true;

      const response = await fetch(localStorage.apiURL + "/app/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
              email: email,
        })
      })
      const data = await response.json();

      if (!data.success){
        if (data.msg == "User not found"){
          this.error("User not found. Try again")
          return
        } else {
          this.error("An error occured " + data.msg);
          return
        }
      }
      alert("Success! A password reset email has been sent.")
      this.$router.push({path: 'login'});
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 1500px) {
  #password-form {
    margin-top: 25px;
    margin-left: 20px;
    margin-right: 20px;
    align-content: center;
  }
}
@media screen and (min-width: 1500px) {
#password-form {
  margin-top: 100px;
  align-content: center;
  width: 50%
}
}
#password-header {
  text-align: center;
}
</style>